import { render, staticRenderFns } from "./GenericAccordion.vue?vue&type=template&id=6c64cd98"
import script from "./GenericAccordion.vue?vue&type=script&lang=js"
export * from "./GenericAccordion.vue?vue&type=script&lang=js"
import style0 from "./GenericAccordion.vue?vue&type=style&index=0&id=6c64cd98&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports